var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlarm = function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M6.25 10a5.75 5.75 0 1 1 11.5 0v5.25H19v1.5h-3.326a3.75 3.75 0 0 1-7.348 0H5v-1.5h1.25zm1.5 5.25h8.5V10a4.25 4.25 0 0 0-8.5 0zm2.129 1.5a2.251 2.251 0 0 0 4.242 0z",
    clipRule: "evenodd"
  })));
};
export default SvgAlarm;